import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';

const ConfirmEmail: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const [params] = useSearchParams();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState<string>('');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; // guard double-invoke (StrictMode)
    ranRef.current = true;
    const userId = params.get('k') || params.get('userId') || '';
    const code = params.get('c') || params.get('code') || '';
    const run = async () => {
      try {
        await api.post('/auth/confirm-email', null, { params: { userId, code } });
        setStatus('success');
        setMessage(t('auth.emailConfirmedRedirect', 'Your email has been confirmed. Redirecting to login...'));
        // Ensure any existing session is cleared to avoid landing as logged-in
        try { await api.post('/auth/logout'); } catch {}
        // Hard redirect to login to prevent back navigation restoring session
        setTimeout(() => { window.location.replace('/login?signupSuccess=true'); }, 800);
      } catch (e: any) {
        setStatus('error');
        const msg = e?.response?.data?.message || t('auth.invalidConfirmationLink', 'Invalid or expired confirmation link.');
        setMessage(msg);
      }
    };
    if (userId && code) run(); else { setStatus('error'); setMessage(t('auth.invalidConfirmationLink', 'Invalid or expired confirmation link.')); }
  }, [params, t]);

  return (
    <div className="min-h-[50vh] grid place-items-center" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-2">{t('auth.emailConfirmation', 'Email Confirmation')}</h1>
        <p className="text-gray-600 mb-2">{message}</p>
        {status === 'pending' && (
          <p className="text-gray-500">{t('common.loading', 'Loading...')}</p>
        )}
        {/* On success we auto-redirect; on error, no buttons needed */}
      </div>
    </div>
  );
};

export default ConfirmEmail;


